import React, { useCallback, useEffect, useState } from 'react';
import ContractHistoryDetail from './ContractHistoryDetail';
import { useSelector } from 'react-redux';
import { IAllStates } from '../../../../../../../../store/rootReducer';
import { ErrorToast } from '../../../../../../../../utils/toasters';
import { ContractService } from '../../../../service';
import { IContract } from '../../../../../../../../model/shared/IContract';

export function ContractHistory() {
    const { campaign, isCharity } = useSelector((state: IAllStates) => state.contractBrand);
    const [historyContracts, setHistoryContracts] = useState<IContract[]>([]);

    const historyRequest = useCallback(() => {
        ContractService.getHistoryContracts(campaign?.contracts[0]?.id)
            .then(response => setHistoryContracts(response))
            .catch(err => ErrorToast(err));
    }, []);

    useEffect(() => {
        historyRequest();
    }, [historyRequest]);

    return (
        <>
            {historyContracts.map(contract => (
                <ContractHistoryDetail key={contract?.id} contract={contract} isCharity={isCharity} />
            ))}
        </>
    );
}
